import { WidthContainer } from '@pata-app/ui-document';



import React from 'react';
import { useTheme } from 'styled-components';



import SectionContainer from '../../../../components/sectionContainer/sectionContainer';
import { testimonialOptions, Testimoninal } from '../../../../components/testimoninal/testimoninal';
import { TextWithHighlight } from '../../../../components/textWithHighlight/textWithHighlight';


const TestimoninalTitle = () => {
  return (
    <TextWithHighlight>
      <h2>
        Why <strong>pet pros </strong>
        trust Pata booking software
      </h2>
    </TextWithHighlight>
  );
};

const TestimoninalSubTitle = () => {
  return (
    <p style={{ maxWidth: '850px' }}>
      We think our booking platform can make a world of difference, but don't just take our word for it. Here's why pet
      pros love using Pata to manage bookings, reduce admin and grow their pet business.
    </p>
  );
};

export function FeaturesTestimoninal() {
  // const theme = useTheme();

  const businessTestimoninalConfig = [
    {
      children: testimonialOptions.pet_palace,
      color: '#f5c14f',
    },
    {
      children: testimonialOptions.whitegates_grooming,
      color: '#f86e6a',
    },
    {
      children: testimonialOptions.talk_of_the_dog,
      color: '#117191',
    },
    {
      children: testimonialOptions.mias_paw_spa,
      color: '#f5a046',
    },
    {
      children: testimonialOptions.canine_body_works,
      color: '#90cfd1',
    },
    {
      children: testimonialOptions.pawfect_place,
      color: '#8cc4b8',
    },
  ];

  return (
    <WidthContainer noBackground>
      <SectionContainer title={TestimoninalTitle} subTitle={TestimoninalSubTitle}>
        <Testimoninal testimonialConfig={businessTestimoninalConfig} />
      </SectionContainer>
    </WidthContainer>
  );
}